import {gsap} from 'gsap/gsap-core'

export class Menu {
    constructor() {
        this.el = document.querySelector('.menu')
        this.hamburgerIcon = this.el.querySelector('.menu__icon')
        this.menuContent = document.querySelector('.menu__content')
        this.closeIcon = this.menuContent.querySelector('.menu__icon')

        this._setupEvents()
    }

    _setupEvents() {
        this.hamburgerIcon.addEventListener('click', (e) => {
            e.preventDefault()
            this.menuContent.style.display = 'block'

            gsap.to(this.menuContent, { opacity: 1})
        })

        this.closeIcon.addEventListener('click', (e) => {
            e.preventDefault()

            gsap.to(this.menuContent, { opacity: 0, onComplete: () => {
                    this.menuContent.style.display = 'none'
                }})
        })
    }

}
